import React from 'react';

const NavItem = ({ children }) => {
  return (
    <div className="c-side-menu__nav-item">
      {children}
    </div>
  );
};

export default NavItem;



// WEBPACK FOOTER //
// ./src/components/IterioApp/sideMenu/components/NavItem/NavItem.jsx